import styled from 'styled-components';

const StyledNotFoundComponent = styled.div`
`;
export {
  StyledNotFoundComponent
};
